import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetFiltersOptionsMutation } from "../../../dataApiSlice";
import CheckBoxComp from "./FilterConfigCompComponents/CheckBoxComp";
import { getL1SheetProperty } from "../../../WorkbookSlice";
import BetweenOperatorComp from "./FilterConfigCompComponents/BetweenOperatorComp";
import { nanoid } from "@reduxjs/toolkit";
import { RxCross2 } from "react-icons/rx";
import LoadingIndicator from "../../../../../components/BasicComponents/LoadingIndicator";
import DateBetweenComp from "./Date/DateBetweenComp";
import { format as formatDateByDateFNS, parseISO, parse } from "date-fns";
import SelectBox from "./FilterConfigCompComponents/SelectBox";
const measureOption = [
  {
    label: "Maximun",
    value: "MAX",
  },
  {
    label: "Minimum",
    value: "MIN",
  },
  {
    label: "Avgrage",
    value: "AVG",
  },
  {
    label: "Sum",
    value: "SUM",
  },
  {
    label: "Count",
    value: "COUNT",
  },
  {
    label: "Count Distinct",
    value: "DISTINCT",
  },
  {
    label: "No Calculation",
    value: "NOCALCULATION",
  },
];
const convertToInputDateFormat = (dateStr) => {
  if (!dateStr) return "";
  try {
    const parsedDate = parse(dateStr, "dd/MM/yyyy", new Date());
    return formatDateByDateFNS(parsedDate, "yyyy-MM-dd"); // Correct "MM" instead of "mm"
  } catch (error) {
    console.error("Invalid date format:", dateStr);
    return "";
  }
};

export default function FilterConfigComp({
  Sheetid,
  droppedItem,
  handleClosePopup,
  handleSavePopupFilter,
  a,
  dataSourceID
}) {
  const {
    columnName,
    nanoId: receivednanoId,
    selectedOperator: receivedOperator,
    dataType: receivedDataType,
    minValue: receivedMinValue,
    maxValue: receivedMaxValue,
    selectedMeasure: receivedMeasure,
    selectedFilterValues: receivedSelectedFilterValues,
    filterField: receivedFilterField,
  } = droppedItem;
  // console.log(receivedSelectedFilterValues);

  const filterField = a !== undefined ? a : receivedFilterField;
  const [alreadyExists, setAlreadyExists] = useState(false);
  const [selectedFilterValues, setSelectedFilterValues] = useState(
    Array.isArray(receivedSelectedFilterValues)
      ? receivedSelectedFilterValues
      : []
  );
  // console.log(selectedFilterValues);

  const [options, setOptions] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(receivedOperator);
  const [minValue, setMinValue] = useState(receivedMinValue);
  const [maxValue, setMaxValue] = useState(receivedMaxValue);
  const [activeSave, setActiveSave] = useState(true);
  const [creatednanoId, setCreatednanoId] = useState(nanoid());
  const [selectedMeasure, setSelectedMeasure] = useState(
    receivedMeasure ? receivedMeasure : measureOption[3].value
  );
  const [format, setFormat] = useState(null);
  const [isAll, setIsAll] = useState(false);
  // console.log(droppedItem);
  // console.log(isAll);

  const [getFiltersOptions, { data, isError, error, isLoading, isSuccess }] =
    useGetFiltersOptionsMutation();

  if (isSuccess) {
    // // console.log("Received data:", data);
  }

  useEffect(() => {
    let filterBody, format;
    switch (receivedFilterField ? receivedFilterField : filterField) {
      case "Years":
        format = "YYYY";
        break;
      case "Financial Year":
        format = "FYyyyy-yy";
        break;
      case "Quarter":
        format = "Qx-Fyyyyy-yy";
        break;
      case "Month-year":
        format = "MMM-YY";
        break;
      case "Month":
        format = "MMMM";
        break;
      case "Week":
        format = "Wx";
        break;
      case "Weekday":
        format = "dddd";
        break;
      case "Date (date-month-year)":
        format = "dd-mm-yyyy";
        break;
      case "Date (month-date-year)":
        format = "mm-dd-yyyy";
        break;
      case "'RangeOfDate'":
        format = "DD/MM/YYYY";
        break;
      default:
        // console.log("Filter is null or has an incorrect value");
        format = null; // Explicitly set the format to null for unsupported values
        break;
    }
    // console.log(droppedItem);
    setFormat(format);
    // console.log(droppedItem.dataType === "Date" && format !== null);
    if (droppedItem.dataType === "Date" && format !== null) {
      filterBody = {
        databaseID: dataSourceID,
        columns: [{ name: columnName, format: format }],
        dataType: droppedItem.dataType,
        // yearType: ["Years", "Quarter"].includes(filterField) ? "FY" : null,
      };
    } else if (
      droppedItem.columnType === "calculatedField" &&
      droppedItem.formula !== null
    ) {
      // console.log("dropped item is a calculated Field");
      filterBody = {
        databaseID: dataSourceID,
        columns: [
          {
            name: columnName,
            formula: droppedItem.formula,
            fieldType: "calculatedField",
            dataType: droppedItem.dataType,
          },
        ],
      };
    } else {
      filterBody = {
        databaseID: dataSourceID,
        columns: [{ name: columnName }],
        dataType: droppedItem.dataType,
      };
    }

    // console.log(filterBody);

    if (!data) {
      getFiltersOptions({ filterBody, calledFrom: "filterConfigComp" });
    }

    if (receivednanoId) {
      setAlreadyExists(true);
      setSelectedOperator(receivedOperator);
      if (receivedDataType === "Date" && receivedOperator === "BETWEEN") {
        const convertedStartDate = convertToInputDateFormat(receivedMinValue);
        const convertedEndDate = convertToInputDateFormat(receivedMaxValue);
        setMaxValue(convertedEndDate);
        setMinValue(convertedStartDate);
      } else {
        setMaxValue(receivedMaxValue);
        setMinValue(receivedMinValue);
      }
      setCreatednanoId(receivednanoId);
      setSelectedFilterValues(receivedSelectedFilterValues);
    } else {
      setAlreadyExists(false);
    }
  }, [droppedItem, dataSourceID, columnName]);

  useEffect(() => {
    let newOptions = [];
    let defaultOperator = "";

    if (droppedItem.dataType === "Number") {
      newOptions = [
        { label: "Between", value: "BETWEEN" },
        { label: "Less or Equal (<=)", value: "<=" },
        { label: "Greater or Equal (>=)", value: ">=" },
        { label: "Less Than(<)", value: "<" },
        { label: "Greater Than(>)", value: ">" },
        { label: "Equal To(==)", value: "==" },
      ];
      defaultOperator = newOptions[0].value;
    } else if (droppedItem.dataType === "String") {
      newOptions = [{ label: "In", value: "IN" }];
      defaultOperator = newOptions[0].value;
    } else if (droppedItem.dataType === "Date") {
      if (filterField === "RangeOfDate") {
        newOptions = [{ label: "Between", value: "BETWEEN" }];
      } else {
        newOptions = [
          { label: "In", value: "IN" },
          { label: "Between", value: "BETWEEN" },
        ];
      }
      defaultOperator = newOptions[0].value;
    }

    setOptions(newOptions);

    if (receivedOperator === undefined) {
      setSelectedOperator(defaultOperator);
    } else {
      setSelectedOperator(receivedOperator);
    }
  }, [droppedItem.dataType, receivedOperator]);

  //check parameters to handle save button availability
  useEffect(() => {
    if (
      selectedOperator === "BETWEEN" &&
      (droppedItem.dataType === "Number" || receivedDataType === "Number")
    ) {
      setActiveSave(
        minValue !== undefined && maxValue !== undefined && minValue < maxValue
      );
    } else {
      setActiveSave(minValue !== "");
    }
  }, [selectedOperator, minValue, maxValue]);

  const handleOperatorChange = (e) => {
    const selected = options.find((option) => option.value === e.target.value);
    setSelectedOperator(selected.value);
  };

  const handleMeasureChange = (e) => {
    // console.log(e.target.value);
    const selected = measureOption.find(
      (option) => option.value === e.target.value
    );
    setSelectedMeasure(selected.value);
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isError) {
    return <p>There is an error: {error.message}</p>;
  }

  const renderComponent = ({ selectedOperator, dataType }) => {
    // console.log(data);
    switch (selectedOperator) {
      case "IN":
        if (["String", "Date"].includes(dataType)) {
          return (
            <CheckBoxComp
              data={data}
              selectedFilterValues={
                Array.isArray(selectedFilterValues) ? selectedFilterValues : []
              }
              setSelectedFilterValues={setSelectedFilterValues}
              setIsAll={setIsAll}
              columnName={columnName}
              dataSourceID={dataSourceID}
            />
          );
        }
      case "BETWEEN":
      case ">=":
      case "<=":
      case "<":
      case ">":
      case "==":
        if (dataType === "Number") {
          return (
            <BetweenOperatorComp
              maxValue={maxValue}
              setMaxValue={setMaxValue}
              minValue={minValue}
              setMinValue={setMinValue}
              selectedOperator={selectedOperator}
            />
          );
        }
        if (dataType === "Date") {
          return (
            <DateBetweenComp
              maxValue={maxValue}
              setMaxValue={setMaxValue}
              minValue={minValue}
              setMinValue={setMinValue}
            />
          );
        }
      default:
        return (
          <CheckBoxComp
            data={data}
            selectedFilterValues={selectedFilterValues}
            setSelectedFilterValues={setSelectedFilterValues}
            columnName={columnName}
            dataSourceID={dataSourceID}
          />
        );
    }
  };

  const dispatchableFilterItemIs = (dataType) => {
    // console.log(dataType);
    let filterObject = null;
    if (dataType === "String") {
      filterObject = {
        ...droppedItem,
        nanoId: creatednanoId,
        selectedFilterValues,
        selectedOperator,
        isAll,
        filterType: "permanent",
        visibleFilter: true,
        filterComponentType: "MultiValueDropdown",
        dataSourceID,
        isApplyVisible: false,
      };
    } else if (dataType === "Number") {
      filterObject = {
        ...droppedItem,
        nanoId: creatednanoId,
        selectedFilterValues,
        selectedOperator,
        minValue,
        maxValue,
        selectedMeasure,
        filterType: "permanent",
        visibleFilter: true,
        filterComponentType: "MultiValueDropdown",
        dataSourceID,
        isApplyVisible: false,
      };
      // console.log(filterObject);
    } else if (dataType === "Date") {
      filterObject = {
        ...droppedItem,
        nanoId: creatednanoId,
        selectedFilterValues,
        selectedOperator,
        isAll,
        minValue,
        maxValue,
        filterType: "permanent",
        visibleFilter: true,
        filterComponentType: "MultiValueDropdown",
        dataSourceID,
        isApplyVisible: false,
        format: format,
        filterField: filterField,
        ...{
          minValue:
            selectedOperator === "BETWEEN"
              ? formatDateByDateFNS(parseISO(minValue), "dd/MM/yyyy")
              : "",
        },
        ...{
          maxValue:
            selectedOperator === "BETWEEN"
              ? formatDateByDateFNS(parseISO(maxValue), "dd/MM/yyyy")
              : "",
        },
      };
      // console.log(filterObject);
    } else {
      console.error(`add the case for new dataType ${dataType}`);
    }
    if (filterObject !== null) {
      // console.log(filterObject);
      return filterObject;
    } else {
      return undefined;
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleSavePopupFilter(
        dispatchableFilterItemIs(droppedItem.dataType || receivedDataType),
        alreadyExists
      ); // Call your function here
    }
  };

  if (isSuccess) {
    return (
      <main
        className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-50"
        onKeyDown={handleKeyDown}
      >
        <main className="bg-white p-2 flex flex-col rounded w-96 gap-2 shadow-xl">
          <button className="flex items-center justify-between text-lg font-medium w-full">
            {droppedItem.dataType === "Number"
              ? `${selectedMeasure}(${droppedItem.rename})`
              : droppedItem.rename}
            <RxCross2
              onClick={() => handleClosePopup(droppedItem)}
              className="text-black"
            />
          </button>
          <section className="flex flex-col items-start justify-center gap-4">
            {/* ----mEaSuRe SeLeCtIoN */}
            {droppedItem.dataType === "Number" && (
              <SelectBox
                value={selectedMeasure}
                onChange={handleMeasureChange}
                optionsArray={measureOption}
              />
            )}
            {/* ----oPeRaToR SeLeCtIoN */}
            <SelectBox
              value={selectedOperator}
              onChange={handleOperatorChange}
              optionsArray={options}
            />
          </section>

          {renderComponent({
            selectedOperator,
            dataType: droppedItem.dataType || receivedDataType,
          })}
          <div className="flex justify-end gap-2">
            <button
              onClick={() => handleClosePopup(droppedItem)}
              className="px-4 py-2 font-medium border text-black tracking-wide rounded"
            >
              Close
            </button>
            <button
              onClick={() =>
                handleSavePopupFilter(
                  dispatchableFilterItemIs(
                    droppedItem.dataType || receivedDataType
                  ),
                  alreadyExists
                )
              }
              className={`text-white px-4 py-2 font-medium tracking-wide rounded ${activeSave ? "bg-blue-950" : "bg-gray-200"
                }`}
              disabled={!activeSave}
            >
              Save
            </button>
          </div>
        </main>
      </main>
    );
  }
  return null; // Add a return statement to handle the case when none of the conditions are met
}
